import { useAuth } from "@/context/AuthContext";
import AuthLayout from "@/components/AuthLayout";
import { MfaEnrol } from "@/components/workspace/SecurityCards";

export default function MfaSetupGate() {
  const { user, logout, refreshUser } = useAuth();
  return (
    <AuthLayout eyebrow={`Required by ${user.workspace?.name || "your workspace"}`} title="Set up two-step sign-in">
      <div className="space-y-5" data-testid="mfa-gate">
        <p className="text-sm text-muted-foreground">Your workspace requires every admin to add a six-digit code from an authenticator app to their password. It takes about a minute; nothing else opens until it's done.</p>
        <MfaEnrol onDone={refreshUser} onCancel={null} />
        <button type="button" className="text-xs text-muted-foreground underline-offset-4 hover:underline" onClick={logout} data-testid="mfa-gate-signout">Sign out instead</button>
      </div>
    </AuthLayout>
  );
}
